import React, { memo } from "react";

import { Navigate } from "react-router-dom";

import { PageLoadingElevaty } from "../components/LoadingElevaty/PageLoadingElevaty";
import { usePermissions } from "../Context/permissionContext";
import { useAuth } from "../hooks/AuthProvider";
import useSocket from "../hooks/useSocket";
import { storageService } from "../services/storageService";
import { isTypeUser } from "../utils/isTypeUser";

function PrivateRouterComponent({ children }) {
  useSocket("user:deactivateUser");
  const jwt = storageService.getToken();
  if (!jwt) {
    return <Navigate to={{ pathname: "/" }} />;
  }
  return children;
}

export const PrivateRouter = memo(PrivateRouterComponent);

function PermissionRouterComponent({
  children,
  permission,
  onlyForRpeUsers = false,
  onlyForRpeRoleUsers = false,
}) {
  const { permissions, isLoading } = usePermissions();
  const { user } = useAuth();

  if (isLoading) {
    return <PageLoadingElevaty />;
  }

  if (!permissions || !permissions.includes(permission)) {
    return <Navigate to={{ pathname: "/home" }} />;
  }

  if (onlyForRpeUsers || onlyForRpeRoleUsers) {
    if (!user) {
      return <PageLoadingElevaty />;
    }

    if (onlyForRpeUsers && !isTypeUser("RPE", user?.type_user)) {
      return <Navigate to={{ pathname: "/home" }} />;
    }

    if (onlyForRpeRoleUsers && !isTypeUser("RPE", user?.type_role_user)) {
      return <Navigate to={{ pathname: "/home" }} />;
    }
  }

  return <PrivateRouter>{children}</PrivateRouter>;
}

export const PermissionRouter = memo(PermissionRouterComponent);
